import { Notification } from "@fixa/notifications";
import NotificationTaskNotificationFactory from "./task-notification/TaskNotificationFactory";

interface NotificationItemProps {
  notification: Notification;
  onClick: (notificationId: string) => void;
}
export const NotificationItem = ({
  notification,
  onClick,
}: NotificationItemProps) => {
  const { read, createdAt, id, content, contentType } = notification;
  const extraProps = {
    read,
    createdAt,
    onClick: () => onClick(id),
  };
  const props = { ...extraProps, content };
  switch (contentType) {
    case "task-notification":
      return <NotificationTaskNotificationFactory {...props} />;
    default:
      return null;
  }
};
